import type { AppShellMenuItem } from "./appShellMenu";
import { spacing } from "./spacing";
import { AttentionIndicator } from "../ui/AttentionIndicator";
export function AppShellMenuLabel({ item }: { item: AppShellMenuItem }) {
  if (!item.attention) return item.label;
  return <span style={{ display: "inline-flex", alignItems: "center", gap: spacing.tightGap }}>
    <span>{item.label}</span>
    <AttentionIndicator {...item.attention} className="mq-app-shell-count" />
  </span>;
}
